import React from 'react';
import { Route, Switch } from 'react-router-dom';
import * as routes from 'routes';

import AccountDetail from 'pages/Accounts/Detail/index';
import ClientError from 'pages/Error/ClientError';

const ClientAppRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path={[routes.CLIENT_ERROR]} component={ClientError} />
      <Route component={AccountDetail} />
    </Switch>
  );
};

export default ClientAppRoutes;
